import { Injectable } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProgressBarService {
  public count = new BehaviorSubject<number>(0);
  public isLoading = this.count.pipe(map((count) => count > 0));
  public uploadProgress = new BehaviorSubject<number>(0);

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.start();
      }
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.stop();
      }
    });
  }

  public start() {
    this.count.next(this.count.value + 1);
  }

  public stop() {
    const count = this.count.value;
    if (count === 0) {
      return;
    }

    this.count.next(count - 1);
  }

  public updateUploadProgress(progress: number) {
    this.uploadProgress.next(progress);
  }
}
